// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget--template{width:100%;padding:8px;margin-bottom:4px;color:#000a1e;font-size:16px;border-left:4px solid #fa0019;background:#fff;border-radius:2px;cursor:grab}.widget--template>span{text-align:center}", ""]);
// Exports
module.exports = exports;
